"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID_RE = void 0;
exports.UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
